import $ from 'jquery';

class cdpStatisticsProfilesWithYandex{
  constructor() {
    if ($('#cdp-stat-profiles-with-yandex').length > 0){
      this.loading()
      this.init()
    }
  }

  init(){
    var cdpStat = this;
    $(document).ready(function() {
      setTimeout(function() {
        var result = { query: JSON.stringify(SegmentQueryBuilder.getMongoQuery()) };
        $.ajax({
          url: $('#cdp-stat-profiles-with-yandex').data('url'),
          method: 'GET',
          data: result,
          success: function (response) {
            cdpStat.renderStats(response)
          }
        });
      }, 1000);
    })
  }

  renderStats(response){
    $('#cdp-stat-profiles-with-yandex h6').text(`${this.transform(response.profiles_count)} (${this.transform(response.profiles_percentage)}%)`);
    this.loaded();
  }

  loading(){
    $('#cdp-stat-profiles-with-yandex').addClass('loading');
  }

  loaded(){
    $('#cdp-stat-profiles-with-yandex').removeClass('loading');
  }

  transform(number) {
    return parseFloat(number).toLocaleString("ru")
  }
}

export default cdpStatisticsProfilesWithYandex;